import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import { useNavigate } from "react-router-dom";
import useAuthContext from "../../context/AuthContext";
import { useEffect, useState } from "react";
import { Menu } from "@mui/icons-material";
import SideBar from "./components/General/SideBar";
import DashBar from "./components/General/DashBar";
import Main from "./components/General/Main";

function Dashboard() {
  const navigate = useNavigate();
  const { logout } = useAuthContext();
  const [mobileOpen, setMobileOpen] = useState(false);

  const toggleSidebar = () => setMobileOpen(!mobileOpen);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1200) {
        setMobileOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <Box>
      <DashBar />
      <Toolbar />
      <Box className="dashboard">
        <div className={`layout ${mobileOpen ? "show" : ""}`}></div>
        <div className={`${mobileOpen ? "open" : ""}`}>
          <SideBar handleLogout={handleLogout} mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} handleDrawerToggle={toggleSidebar} />
        </div>
        <div className="main">
          <button onClick={toggleSidebar} className="menu-btn">
            <Menu />
          </button>
          <Main />
        </div>
      </Box>
    </Box>
  );
}

export default Dashboard;
